import { Box, Stack, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)``;

export const SearchBox = styled(Box)`
  flex: 2;

  .MuiInputBase-root {
    background: ${(p) => p.theme.palette.common.white};
  }
`;

export const Input = styled(TextField)`
  width: 100%;

  > div {
    display: flex;
    height: ${(p) => p.theme.spacing(4.5)};
    padding: 15px 7px 15px 11px;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    border-radius: ${(p) => p.theme.spacing(1)};
    gap: 10px;
  }

  & svg {
    color: ${(p) => p.theme.palette.text.disabled};
    font-size: 24px;
  }

  input::placeholder {
    font-size: ${(p) => p.theme.typography.caption};
    color: ${(p) => p.theme.palette.grey[400]};
  }
`;
